<template>
  <div class="md-layout">
    <div class="md-layout-item md-size-100">
      <ValidationObserver v-slot="{ handleSubmit }">
        <form @submit.prevent="handleSubmit(submit)">
          <md-card>
            <md-card-header class="md-card-header-text md-card-header-green">
              <div class="card-text">
                <h4 class="title">{{ formTitle }}</h4>
              </div>
            </md-card-header>

            <div class="management-uni-rating-container">
              <router-link
                data-toggle="dropdown"
                class="edit-btn"
                v-if="id"
                :to="{ name: 'ManageUniversityRatings', params: { id: id } }"
              >
                <p class="content-button">
                  {{ $t("university.manage_score") }}
                </p>
              </router-link>
            </div>

            <md-card-content>
              <div class="md-layout text-center">
                <div class="md-layout-item md-size-100 md-xsmall-size-100">
                  <div class="md-layout">
                    <div class="md-layout-item md-size-100 md-xsmall-size-100">
                      <div class="md-layout">
                        <!-- Avatar -->
                        <div
                          class="md-layout-item md-size-50 md-xsmall-size-100"
                          id="uni-avatar"
                        >
                          <h4 class="card-title">
                            {{ $t("university.avatar") }}
                          </h4>
                          <div class="file-input img-circle">
                            <template v-if="!imageCircle">
                              <div class="image-fix-container">
                                <img :src="avatarImg" title="" />
                              </div>
                            </template>
                            <div class="image-fix-container" v-else>
                              <img :src="imageCircle" />
                            </div>
                            <div class="button-container">
                              <md-button
                                class="md-success md-round md-fileinput"
                                @click="onFileChange"
                              >
                                <template v-if="!imageCircle"
                                  >{{ $t("user.add_avatar") }}
                                </template>
                                <template v-else
                                  >{{ $t("user.change_avatar") }}
                                </template>
                              </md-button>
                            </div>
                          </div>
                        </div>

                        <!-- Cover -->
                        <div
                          class="md-layout-item md-size-50 md-xsmall-size-100"
                          id="uni-cover"
                        >
                          <h4 class="card-title">
                            {{ $t("university.cover_image") }}
                          </h4>
                          <div class="file-input img-circle">
                            <template v-if="!coverImageCircle">
                              <div class="image-fix-container">
                                <img :src="avatarImg" title="" />
                              </div>
                            </template>
                            <div class="image-fix-container" v-else>
                              <img :src="coverImageCircle" />
                            </div>
                            <div class="button-container">
                              <md-button
                                class="md-success md-round md-fileinput"
                                @click="onFileChangeCover"
                              >
                                <template v-if="!coverImageCircle"
                                  >{{ $t("university.add_cover_image") }}
                                </template>
                                <template v-else
                                  >{{ $t("university.change_cover_image") }}
                                </template>
                              </md-button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <!-- Left  -->
                    <div class="md-layout-item md-size-50 md-xsmall-size-100">
                      <div class="md-layout">
                        <!--   Name    -->
                        <div
                          class="md-layout-item md-size-100 md-xsmall-size-100"
                        >
                          <div class="md-layout">
                            <label
                              class="md-layout-item md-size-20 md-xsmall-size-100  md-form-label required-field"
                              :for="$t('university.name')"
                            >
                              {{ $t("university.name") }}
                            </label>
                            <div class="md-layout-item md-xsmall-size-100">
                              <ValidationProvider
                                :name="$t('university.name')"
                                rules="required"
                                v-slot="{ passed, failed, errors }"
                              >
                                <md-field
                                  :class="[
                                    { 'md-error': failed },
                                    { 'md-valid': passed }
                                  ]"
                                >
                                  <md-input v-model="params.name" type="text">
                                  </md-input>

                                  <slide-y-down-transition>
                                    <md-icon class="error" v-show="failed"
                                      >close
                                    </md-icon>
                                  </slide-y-down-transition>
                                  <slide-y-down-transition>
                                    <md-icon class="success" v-show="passed"
                                      >done
                                    </md-icon>
                                  </slide-y-down-transition>
                                </md-field>
                                <div class="validate-error">
                                  {{ errors[0] }}
                                </div>
                              </ValidationProvider>
                            </div>
                          </div>
                        </div>

                        <!--   vi_name    -->
                        <div
                          class="md-layout-item md-size-100 md-xsmall-size-100"
                        >
                          <div class="md-layout">
                            <label
                              class="md-layout-item md-size-20 md-xsmall-size-100  md-form-label required-field"
                              :for="$t('university.vi_name')"
                            >
                              {{ $t("university.vi_name") }}
                            </label>
                            <div
                              class="md-layout-item md-size-80 md-xsmall-size-100"
                            >
                              <ValidationProvider
                                :name="$t('university.vi_name')"
                                rules="required"
                                v-slot="{ passed, failed, errors }"
                              >
                                <md-field
                                  :class="[
                                    { 'md-error': failed },
                                    { 'md-valid': passed }
                                  ]"
                                >
                                  <md-input
                                    v-model="params.vi_name"
                                    type="text"
                                  >
                                  </md-input>

                                  <slide-y-down-transition>
                                    <md-icon class="error" v-show="failed"
                                      >close
                                    </md-icon>
                                  </slide-y-down-transition>
                                  <slide-y-down-transition>
                                    <md-icon class="success" v-show="passed"
                                      >done
                                    </md-icon>
                                  </slide-y-down-transition>
                                </md-field>
                                <div class="validate-error">
                                  {{ errors[0] }}
                                </div>
                              </ValidationProvider>
                            </div>
                          </div>
                        </div>

                        <!--   parent_name    -->
                        <!--                        <div-->
                        <!--                          class="md-layout-item md-size-100 md-xsmall-size-100"-->
                        <!--                        >-->
                        <!--                          <div class="md-layout">-->
                        <!--                            <label-->
                        <!--                              class="md-layout-item md-size-20 md-xsmall-size-100  md-form-label"-->
                        <!--                              :for="$t('university.parent_name')"-->
                        <!--                            >-->
                        <!--                              {{ $t("university.parent_name") }}-->
                        <!--                            </label>-->
                        <!--                            <div-->
                        <!--                              class="md-layout-item md-size-80 md-xsmall-size-100"-->
                        <!--                            >-->
                        <!--                              <ValidationProvider-->
                        <!--                                :name="$t('university.parent_name')"-->
                        <!--                                rules=""-->
                        <!--                                v-slot="{ passed, failed, errors }"-->
                        <!--                              >-->
                        <!--                                <md-field-->
                        <!--                                  :class="[-->
                        <!--                                    { 'md-error': failed },-->
                        <!--                                    { 'md-valid': passed }-->
                        <!--                                  ]"-->
                        <!--                                >-->
                        <!--                                  <div class="form-select2-container">-->
                        <!--                                    <select2-->
                        <!--                                      v-model="params.parent_id"-->
                        <!--                                      :name="$t('university.parent_name')"-->
                        <!--                                      :options="universityOptions"-->
                        <!--                                      :settings="{-->
                        <!--                                        dropdownAutoWidth: true,-->
                        <!--                                        width: 'inherit'-->
                        <!--                                      }"-->
                        <!--                                    />-->
                        <!--                                  </div>-->

                        <!--                                  <slide-y-down-transition>-->
                        <!--                                    <md-icon class="error" v-show="failed"-->
                        <!--                                      >close</md-icon-->
                        <!--                                    >-->
                        <!--                                  </slide-y-down-transition>-->
                        <!--                                  <slide-y-down-transition>-->
                        <!--                                    <md-icon class="success" v-show="passed"-->
                        <!--                                      >done</md-icon-->
                        <!--                                    >-->
                        <!--                                  </slide-y-down-transition>-->
                        <!--                                </md-field>-->
                        <!--                                <div class="validate-error">-->
                        <!--                                  {{ errors[0] }}-->
                        <!--                                </div>-->
                        <!--                              </ValidationProvider>-->
                        <!--                            </div>-->
                        <!--                          </div>-->
                        <!--                        </div>-->

                        <!--   university_division    -->
                        <div
                          class="md-layout-item md-size-100 md-xsmall-size-100"
                        >
                          <div class="md-layout">
                            <label
                              class="md-layout-item md-size-20 md-xsmall-size-100  md-form-label required-field"
                              :for="$t('university.university_division_name')"
                            >
                              {{ $t("university.university_division_name") }}
                            </label>
                            <div
                              class="md-layout-item md-size-80 md-xsmall-size-100"
                            >
                              <ValidationProvider
                                :name="
                                  $t('university.university_division_name')
                                "
                                rules="required"
                                v-slot="{ passed, failed, errors }"
                              >
                                <md-field
                                  :class="[
                                    { 'md-error': failed },
                                    { 'md-valid': passed }
                                  ]"
                                >
                                  <md-select
                                    v-model="params.university_division_id"
                                    :name="
                                      $t('university.university_type_name')
                                    "
                                  >
                                    <md-option
                                      :value="option.id"
                                      v-for="option in universityDivisionOptions"
                                      :key="option.id"
                                      >{{ option.name }}
                                    </md-option>
                                  </md-select>

                                  <slide-y-down-transition>
                                    <md-icon class="error" v-show="failed"
                                      >close
                                    </md-icon>
                                  </slide-y-down-transition>
                                  <slide-y-down-transition>
                                    <md-icon class="success" v-show="passed"
                                      >done
                                    </md-icon>
                                  </slide-y-down-transition>
                                </md-field>
                                <div class="validate-error">
                                  {{ errors[0] }}
                                </div>
                              </ValidationProvider>
                            </div>
                          </div>
                        </div>

                        <!--   university_type    -->
                        <div
                          class="md-layout-item md-size-100 md-xsmall-size-100"
                        >
                          <div class="md-layout">
                            <label
                              class="md-layout-item md-size-20 md-xsmall-size-100  md-form-label required-field"
                              :for="$t('university.university_type_name')"
                            >
                              {{ $t("university.university_type_name") }}
                            </label>
                            <div
                              class="md-layout-item md-size-80 md-xsmall-size-100"
                            >
                              <ValidationProvider
                                :name="$t('university.university_type_name')"
                                rules="required"
                                v-slot="{ passed, failed, errors }"
                              >
                                <md-field
                                  :class="[
                                    { 'md-error': failed },
                                    { 'md-valid': passed }
                                  ]"
                                >
                                  <md-select
                                    v-model="params.university_type_id"
                                    :name="
                                      $t('university.university_type_name')
                                    "
                                  >
                                    <md-option
                                      :value="option.id"
                                      v-for="option in universityTypeOptions"
                                      :key="option.id"
                                      >{{ option.name }}
                                    </md-option>
                                  </md-select>

                                  <slide-y-down-transition>
                                    <md-icon class="error" v-show="failed"
                                      >close
                                    </md-icon>
                                  </slide-y-down-transition>
                                  <slide-y-down-transition>
                                    <md-icon class="success" v-show="passed"
                                      >done
                                    </md-icon>
                                  </slide-y-down-transition>
                                </md-field>
                                <div class="validate-error">
                                  {{ errors[0] }}
                                </div>
                              </ValidationProvider>
                            </div>
                          </div>
                        </div>

                        <!--   nation    -->
                        <div
                          class="md-layout-item md-size-100 md-xsmall-size-100"
                        >
                          <div class="md-layout">
                            <label
                              class="md-layout-item md-size-20 md-xsmall-size-100  md-form-label required-field"
                              :for="$t('university.nation')"
                            >
                              {{ $t("university.nation") }}
                            </label>
                            <div
                              class="md-layout-item md-size-80 md-xsmall-size-100"
                            >
                              <ValidationProvider
                                :name="$t('university.nation')"
                                rules="required"
                                v-slot="{ passed, failed, errors }"
                              >
                                <md-field
                                  :class="[
                                    { 'md-error': failed },
                                    { 'md-valid': passed }
                                  ]"
                                >
                                  <div class="form-select2-container">
                                    <select2
                                      v-model="params.country_alpha_two_code"
                                      :name="$t('university.nation')"
                                      :options="nationOptions"
                                      :settings="{
                                        dropdownAutoWidth: true,
                                        width: 'inherit'
                                      }"
                                    />
                                  </div>

                                  <slide-y-down-transition>
                                    <md-icon class="error" v-show="failed"
                                      >close
                                    </md-icon>
                                  </slide-y-down-transition>
                                  <slide-y-down-transition>
                                    <md-icon class="success" v-show="passed"
                                      >done
                                    </md-icon>
                                  </slide-y-down-transition>
                                </md-field>
                                <div class="validate-error">
                                  {{ errors[0] }}
                                </div>
                              </ValidationProvider>
                            </div>
                          </div>
                        </div>

                        <!--   address    -->
                        <div
                          class="md-layout-item md-size-100 md-xsmall-size-100"
                        >
                          <div class="md-layout">
                            <label
                              class="md-layout-item md-size-20 md-xsmall-size-100  md-form-label required-field"
                              :for="$t('university.address')"
                            >
                              {{ $t("university.address") }}
                            </label>
                            <div
                              class="md-layout-item md-size-80 md-xsmall-size-100"
                            >
                              <ValidationProvider
                                :name="$t('university.address')"
                                rules="required"
                                v-slot="{ passed, failed, errors }"
                              >
                                <md-field
                                  :class="[
                                    { 'md-error': failed },
                                    { 'md-valid': passed }
                                  ]"
                                >
                                  <md-input
                                    v-model="params.address"
                                    type="text"
                                  >
                                  </md-input>

                                  <slide-y-down-transition>
                                    <md-icon class="error" v-show="failed"
                                      >close
                                    </md-icon>
                                  </slide-y-down-transition>
                                  <slide-y-down-transition>
                                    <md-icon class="success" v-show="passed"
                                      >done
                                    </md-icon>
                                  </slide-y-down-transition>
                                </md-field>
                                <div class="validate-error">
                                  {{ errors[0] }}
                                </div>
                              </ValidationProvider>
                            </div>
                          </div>
                        </div>

                        <!--   cover_image    -->
                        <!--                        <div-->
                        <!--                          class="md-layout-item md-size-100 md-xsmall-size-100"-->
                        <!--                        >-->
                        <!--                          <div class="md-layout">-->
                        <!--                            <label-->
                        <!--                              class="md-layout-item md-size-20 md-xsmall-size-100 required-field  md-form-label"-->
                        <!--                              :for="$t('university.cover_image')"-->
                        <!--                            >-->
                        <!--                              {{ $t("university.cover_image") }}-->
                        <!--                            </label>-->
                        <!--                            <div-->
                        <!--                              class="md-layout-item md-size-80 md-xsmall-size-100"-->
                        <!--                            >-->
                        <!--                              <ValidationProvider-->
                        <!--                                :name="$t('university.cover_image')"-->
                        <!--                                rules="required"-->
                        <!--                                v-slot="{ passed, failed, errors }"-->
                        <!--                              >-->
                        <!--                                <md-field-->
                        <!--                                  :class="[-->
                        <!--                                    { 'md-error': failed },-->
                        <!--                                    { 'md-valid': passed }-->
                        <!--                                  ]"-->
                        <!--                                >-->
                        <!--                                  <md-file-->
                        <!--                                    accept="image/*"-->
                        <!--                                    v-model="coverImage"-->
                        <!--                                    @md-change="changeCoverImg"-->
                        <!--                                  >-->
                        <!--                                  </md-file>-->

                        <!--                                  <slide-y-down-transition>-->
                        <!--                                    <md-icon class="error" v-show="failed"-->
                        <!--                                      >close-->
                        <!--                                    </md-icon>-->
                        <!--                                  </slide-y-down-transition>-->
                        <!--                                  <slide-y-down-transition>-->
                        <!--                                    <md-icon class="success" v-show="passed"-->
                        <!--                                      >done-->
                        <!--                                    </md-icon>-->
                        <!--                                  </slide-y-down-transition>-->
                        <!--                                </md-field>-->
                        <!--                                <div class="validate-error">-->
                        <!--                                  {{ errors[0] }}-->
                        <!--                                </div>-->
                        <!--                              </ValidationProvider>-->
                        <!--                            </div>-->
                        <!--                          </div>-->
                        <!--                        </div>-->

                        <!--   video    -->
                        <div
                          class="md-layout-item md-size-100 md-xsmall-size-100"
                        >
                          <div class="md-layout">
                            <label
                              class="md-layout-item md-size-20 md-xsmall-size-100  md-form-label"
                              :for="$t('university.video')"
                            >
                              {{ $t("university.video") }}
                            </label>
                            <div
                              class="md-layout-item md-size-80 md-xsmall-size-100"
                            >
                              <ValidationProvider
                                :name="$t('university.video')"
                                rules="validUrl"
                                v-slot="{ passed, failed, errors }"
                              >
                                <md-field
                                  :class="[
                                    { 'md-error': failed },
                                    { 'md-valid': passed }
                                  ]"
                                >
                                  <!--                                  <md-file-->
                                  <!--                                    @md-change="changeVideo"-->
                                  <!--                                    accept="video/*"-->
                                  <!--                                    v-model="video"-->
                                  <!--                                  >-->
                                  <!--                                  </md-file>-->
                                  <md-input
                                    v-model="params.video"
                                    type="text"
                                  />

                                  <slide-y-down-transition>
                                    <md-icon class="error" v-show="failed"
                                      >close
                                    </md-icon>
                                  </slide-y-down-transition>
                                  <slide-y-down-transition>
                                    <md-icon class="success" v-show="passed"
                                      >done
                                    </md-icon>
                                  </slide-y-down-transition>
                                </md-field>
                                <div class="validate-error">
                                  {{ errors[0] }}
                                </div>
                              </ValidationProvider>
                            </div>
                          </div>
                        </div>

                        <!--   url    -->
                        <div
                          class="md-layout-item md-size-100 md-xsmall-size-100"
                        >
                          <div class="md-layout">
                            <label
                              class="md-layout-item md-size-20 md-xsmall-size-100  md-form-label"
                              :for="$t('university.url')"
                            >
                              {{ $t("university.url") }}
                            </label>
                            <div
                              class="md-layout-item md-size-80 md-xsmall-size-100"
                            >
                              <ValidationProvider
                                :name="$t('university.url')"
                                rules="validUrl"
                                v-slot="{ passed, failed, errors }"
                              >
                                <md-field
                                  :class="[
                                    { 'md-error': failed },
                                    { 'md-valid': passed }
                                  ]"
                                >
                                  <md-input v-model="params.url" type="text">
                                  </md-input>

                                  <slide-y-down-transition>
                                    <md-icon class="error" v-show="failed"
                                      >close
                                    </md-icon>
                                  </slide-y-down-transition>
                                  <slide-y-down-transition>
                                    <md-icon class="success" v-show="passed"
                                      >done
                                    </md-icon>
                                  </slide-y-down-transition>
                                </md-field>
                                <div class="validate-error">
                                  {{ errors[0] }}
                                </div>
                              </ValidationProvider>
                            </div>
                          </div>
                        </div>

                        <!--   is_public    -->
                        <div
                          class="md-layout-item md-size-100 md-xsmall-size-100 text-align-left"
                        >
                          <div class="md-layout">
                            <div
                              class="md-layout-item md-size-20 md-xsmall-size-100"
                            ></div>
                            <div
                              class="md-layout-item md-size-80 md-xsmall-size-100"
                            >
                              <ValidationProvider
                                :name="$t('university.is_public')"
                                rules=""
                                v-slot="{ passed, failed, errors }"
                              >
                                <md-checkbox v-model="params.is_public">
                                  {{ $t("university.is_public") }}
                                </md-checkbox>
                                <div class="validate-error">
                                  {{ errors[0] }}
                                </div>
                              </ValidationProvider>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <!--  Right  -->
                    <div class="md-layout-item md-size-50 md-xsmall-size-100">
                      <div class="md-layout">
                        <!-- Total  traning size  -->
                        <div
                          class="md-layout-item md-size-100 md-xsmall-size-100"
                        >
                          <div class="uni-count-container">
                            <h4 class="text-align-left">
                              {{ $t("university.total_training_size") }}
                            </h4>
                          </div>
                        </div>
                        <!--   undergraduate    -->
                        <div
                          class="md-layout-item md-size-50 md-xsmall-size-100"
                        >
                          <div class="md-layout">
                            <label
                              class="md-layout-item md-size-50 md-xsmall-size-100  md-form-label required-field"
                              :for="$t('university.undergraduate')"
                            >
                              {{ $t("university.undergraduate") }}
                            </label>
                            <div
                              class="md-layout-item md-size-50 md-xsmall-size-100"
                            >
                              <ValidationProvider
                                :name="$t('university.undergraduate')"
                                rules="required|numeric"
                                v-slot="{ passed, failed, errors }"
                              >
                                <md-field
                                  :class="[
                                    { 'md-error': failed },
                                    { 'md-valid': passed }
                                  ]"
                                >
                                  <md-input
                                    v-model="params.undergraduate"
                                    type="number"
                                    min="0"
                                  >
                                  </md-input>

                                  <slide-y-down-transition>
                                    <md-icon class="error" v-show="failed"
                                      >close
                                    </md-icon>
                                  </slide-y-down-transition>
                                  <slide-y-down-transition>
                                    <md-icon class="success" v-show="passed"
                                      >done
                                    </md-icon>
                                  </slide-y-down-transition>
                                </md-field>
                                <div class="validate-error">
                                  {{ errors[0] }}
                                </div>
                              </ValidationProvider>
                            </div>
                          </div>
                        </div>

                        <!--   master    -->
                        <div
                          class="md-layout-item md-size-50 md-xsmall-size-100"
                        >
                          <div class="md-layout">
                            <label
                              class="md-layout-item md-size-50 md-xsmall-size-100  md-form-label required-field"
                              :for="$t('university.master')"
                            >
                              {{ $t("university.master") }}
                            </label>
                            <div
                              class="md-layout-item md-size-50 md-xsmall-size-100"
                            >
                              <ValidationProvider
                                :name="$t('university.master')"
                                rules="required|numeric"
                                v-slot="{ passed, failed, errors }"
                              >
                                <md-field
                                  :class="[
                                    { 'md-error': failed },
                                    { 'md-valid': passed }
                                  ]"
                                >
                                  <md-input
                                    v-model="params.master"
                                    type="number"
                                    min="0"
                                  >
                                  </md-input>

                                  <slide-y-down-transition>
                                    <md-icon class="error" v-show="failed"
                                      >close
                                    </md-icon>
                                  </slide-y-down-transition>
                                  <slide-y-down-transition>
                                    <md-icon class="success" v-show="passed"
                                      >done
                                    </md-icon>
                                  </slide-y-down-transition>
                                </md-field>
                                <div class="validate-error">
                                  {{ errors[0] }}
                                </div>
                              </ValidationProvider>
                            </div>
                          </div>
                        </div>

                        <!--   doctoral    -->
                        <div
                          class="md-layout-item md-size-50 md-xsmall-size-100"
                        >
                          <div class="md-layout">
                            <label
                              class="md-layout-item md-size-50 md-xsmall-size-100  md-form-label required-field"
                              :for="$t('university.doctoral')"
                            >
                              {{ $t("university.doctoral") }}
                            </label>
                            <div
                              class="md-layout-item md-size-50 md-xsmall-size-100"
                            >
                              <ValidationProvider
                                :name="$t('university.doctoral')"
                                rules="required|numeric"
                                v-slot="{ passed, failed, errors }"
                              >
                                <md-field
                                  :class="[
                                    { 'md-error': failed },
                                    { 'md-valid': passed }
                                  ]"
                                >
                                  <md-input
                                    v-model="params.doctoral"
                                    type="number"
                                    min="0"
                                  >
                                  </md-input>

                                  <slide-y-down-transition>
                                    <md-icon class="error" v-show="failed"
                                      >close
                                    </md-icon>
                                  </slide-y-down-transition>
                                  <slide-y-down-transition>
                                    <md-icon class="success" v-show="passed"
                                      >done
                                    </md-icon>
                                  </slide-y-down-transition>
                                </md-field>
                                <div class="validate-error">
                                  {{ errors[0] }}
                                </div>
                              </ValidationProvider>
                            </div>
                          </div>
                        </div>

                        <div
                          class="md-layout-item md-size-100 md-xsmall-size-100"
                        >
                          <md-divider
                            style="    margin: 20px 0px 10px; background: none;"
                          ></md-divider>
                        </div>

                        <!-- End Total traning size  -->

                        <!-- Total number of academics  -->
                        <div
                          class="md-layout-item md-size-100 md-xsmall-size-100"
                        >
                          <div class="uni-count-container">
                            <h4 class="text-align-left">
                              {{ $t("university.total_number_of_academics") }}
                            </h4>
                          </div>
                        </div>

                        <!--   staff_full_time    -->
                        <div
                          class="md-layout-item md-size-50 md-xsmall-size-100"
                        >
                          <div class="md-layout">
                            <label
                              class="md-layout-item md-size-50 md-xsmall-size-100  md-form-label required-field"
                              :for="$t('university.staff_full_time')"
                            >
                              {{ $t("university.staff_full_time") }}
                            </label>
                            <div
                              class="md-layout-item md-size-50 md-xsmall-size-100"
                            >
                              <ValidationProvider
                                :name="$t('university.staff_full_time')"
                                rules="required|numeric"
                                v-slot="{ passed, failed, errors }"
                              >
                                <md-field
                                  :class="[
                                    { 'md-error': failed },
                                    { 'md-valid': passed }
                                  ]"
                                >
                                  <md-input
                                    v-model="params.staff_full_time"
                                    type="number"
                                    min="0"
                                  >
                                  </md-input>

                                  <slide-y-down-transition>
                                    <md-icon class="error" v-show="failed"
                                      >close
                                    </md-icon>
                                  </slide-y-down-transition>
                                  <slide-y-down-transition>
                                    <md-icon class="success" v-show="passed"
                                      >done
                                    </md-icon>
                                  </slide-y-down-transition>
                                </md-field>
                                <div class="validate-error">
                                  {{ errors[0] }}
                                </div>
                              </ValidationProvider>
                            </div>
                          </div>
                        </div>

                        <!--   doctoral_full_time    -->
                        <div
                          class="md-layout-item md-size-50 md-xsmall-size-100"
                        >
                          <div class="md-layout">
                            <label
                              class="md-layout-item md-size-50 md-xsmall-size-100  md-form-label required-field"
                              :for="$t('university.doctoral_full_time')"
                            >
                              {{ $t("university.doctoral_full_time") }}
                            </label>
                            <div
                              class="md-layout-item md-size-50 md-xsmall-size-100"
                            >
                              <ValidationProvider
                                :name="$t('university.doctoral_full_time')"
                                rules="required|numeric"
                                v-slot="{ passed, failed, errors }"
                              >
                                <md-field
                                  :class="[
                                    { 'md-error': failed },
                                    { 'md-valid': passed }
                                  ]"
                                >
                                  <md-input
                                    v-model="params.doctoral_full_time"
                                    type="number"
                                    min="0"
                                  >
                                  </md-input>

                                  <slide-y-down-transition>
                                    <md-icon class="error" v-show="failed"
                                      >close
                                    </md-icon>
                                  </slide-y-down-transition>
                                  <slide-y-down-transition>
                                    <md-icon class="success" v-show="passed"
                                      >done
                                    </md-icon>
                                  </slide-y-down-transition>
                                </md-field>
                                <div class="validate-error">
                                  {{ errors[0] }}
                                </div>
                              </ValidationProvider>
                            </div>
                          </div>
                        </div>

                        <!--   staff_part_time    -->
                        <div
                          class="md-layout-item md-size-50 md-xsmall-size-100"
                        >
                          <div class="md-layout">
                            <label
                              class="md-layout-item md-size-50 md-xsmall-size-100  md-form-label required-field"
                              :for="$t('university.staff_part_time')"
                            >
                              {{ $t("university.staff_part_time") }}
                            </label>
                            <div
                              class="md-layout-item md-size-50 md-xsmall-size-100"
                            >
                              <ValidationProvider
                                :name="$t('university.staff_part_time')"
                                rules="required|numeric"
                                v-slot="{ passed, failed, errors }"
                              >
                                <md-field
                                  :class="[
                                    { 'md-error': failed },
                                    { 'md-valid': passed }
                                  ]"
                                >
                                  <md-input
                                    v-model="params.staff_part_time"
                                    type="number"
                                    min="0"
                                  >
                                  </md-input>

                                  <slide-y-down-transition>
                                    <md-icon class="error" v-show="failed"
                                      >close
                                    </md-icon>
                                  </slide-y-down-transition>
                                  <slide-y-down-transition>
                                    <md-icon class="success" v-show="passed"
                                      >done
                                    </md-icon>
                                  </slide-y-down-transition>
                                </md-field>
                                <div class="validate-error">
                                  {{ errors[0] }}
                                </div>
                              </ValidationProvider>
                            </div>
                          </div>
                        </div>

                        <!--   pap_full_time    -->
                        <div
                          class="md-layout-item md-size-50 md-xsmall-size-100"
                        >
                          <div class="md-layout">
                            <label
                              class="md-layout-item md-size-50 md-xsmall-size-100  md-form-label required-field"
                              :for="$t('university.pap_full_time')"
                            >
                              {{ $t("university.pap_full_time") }}
                            </label>
                            <div
                              class="md-layout-item md-size-50 md-xsmall-size-100"
                            >
                              <ValidationProvider
                                :name="$t('university.pap_full_time')"
                                rules="required|numeric"
                                v-slot="{ passed, failed, errors }"
                              >
                                <md-field
                                  :class="[
                                    { 'md-error': failed },
                                    { 'md-valid': passed }
                                  ]"
                                >
                                  <md-input
                                    v-model="params.pap_full_time"
                                    type="number"
                                    min="0"
                                  >
                                  </md-input>

                                  <slide-y-down-transition>
                                    <md-icon class="error" v-show="failed"
                                      >close
                                    </md-icon>
                                  </slide-y-down-transition>
                                  <slide-y-down-transition>
                                    <md-icon class="success" v-show="passed"
                                      >done
                                    </md-icon>
                                  </slide-y-down-transition>
                                </md-field>
                                <div class="validate-error">
                                  {{ errors[0] }}
                                </div>
                              </ValidationProvider>
                            </div>
                          </div>
                        </div>

                        <!-- END Total number of academics  -->

                        <div
                          class="md-layout-item md-size-100 md-xsmall-size-100"
                        >
                          <md-divider
                            style="margin: 20px 0px 10px; background: none;"
                          ></md-divider>
                        </div>

                        <!-- Total number of education programs  -->
                        <div
                          class="md-layout-item md-size-100 md-xsmall-size-100"
                        >
                          <div class="uni-count-container">
                            <h4 class="text-align-left">
                              {{
                                $t(
                                  "university.total_number_of_education_programs"
                                )
                              }}
                            </h4>
                          </div>
                        </div>

                        <!--   undergraduate_program    -->
                        <div
                          class="md-layout-item md-size-50 md-xsmall-size-100"
                        >
                          <div class="md-layout">
                            <label
                              class="md-layout-item md-size-50 md-xsmall-size-100  md-form-label required-field"
                              :for="$t('university.undergraduate_program')"
                            >
                              {{ $t("university.undergraduate_program") }}
                            </label>
                            <div
                              class="md-layout-item md-size-50 md-xsmall-size-100"
                            >
                              <ValidationProvider
                                :name="$t('university.undergraduate_program')"
                                rules="required|numeric"
                                v-slot="{ passed, failed, errors }"
                              >
                                <md-field
                                  :class="[
                                    { 'md-error': failed },
                                    { 'md-valid': passed }
                                  ]"
                                >
                                  <md-input
                                    v-model="params.undergraduate_program"
                                    type="number"
                                    min="0"
                                  >
                                  </md-input>

                                  <slide-y-down-transition>
                                    <md-icon class="error" v-show="failed"
                                      >close
                                    </md-icon>
                                  </slide-y-down-transition>
                                  <slide-y-down-transition>
                                    <md-icon class="success" v-show="passed"
                                      >done
                                    </md-icon>
                                  </slide-y-down-transition>
                                </md-field>
                                <div class="validate-error">
                                  {{ errors[0] }}
                                </div>
                              </ValidationProvider>
                            </div>
                          </div>
                        </div>

                        <!--   doctoral_program    -->
                        <div
                          class="md-layout-item md-size-50 md-xsmall-size-100"
                        >
                          <div class="md-layout">
                            <label
                              class="md-layout-item md-size-50 md-xsmall-size-100  md-form-label required-field"
                              :for="$t('university.doctoral_program')"
                            >
                              {{ $t("university.doctoral_program") }}
                            </label>
                            <div
                              class="md-layout-item md-size-50 md-xsmall-size-100"
                            >
                              <ValidationProvider
                                :name="$t('university.doctoral_program')"
                                rules="required|numeric"
                                v-slot="{ passed, failed, errors }"
                              >
                                <md-field
                                  :class="[
                                    { 'md-error': failed },
                                    { 'md-valid': passed }
                                  ]"
                                >
                                  <md-input
                                    v-model="params.doctoral_program"
                                    type="number"
                                    min="0"
                                  >
                                  </md-input>

                                  <slide-y-down-transition>
                                    <md-icon class="error" v-show="failed"
                                      >close
                                    </md-icon>
                                  </slide-y-down-transition>
                                  <slide-y-down-transition>
                                    <md-icon class="success" v-show="passed"
                                      >done
                                    </md-icon>
                                  </slide-y-down-transition>
                                </md-field>
                                <div class="validate-error">
                                  {{ errors[0] }}
                                </div>
                              </ValidationProvider>
                            </div>
                          </div>
                        </div>

                        <!--   master_program    -->
                        <div
                          class="md-layout-item md-size-50 md-xsmall-size-100"
                        >
                          <div class="md-layout">
                            <label
                              class="md-layout-item md-size-50 md-xsmall-size-100  md-form-label required-field"
                              :for="$t('university.master_program')"
                            >
                              {{ $t("university.master_program") }}
                            </label>
                            <div
                              class="md-layout-item md-size-50 md-xsmall-size-100"
                            >
                              <ValidationProvider
                                :name="$t('university.master_program')"
                                rules="required|numeric"
                                v-slot="{ passed, failed, errors }"
                              >
                                <md-field
                                  :class="[
                                    { 'md-error': failed },
                                    { 'md-valid': passed }
                                  ]"
                                >
                                  <md-input
                                    v-model="params.master_program"
                                    type="number"
                                    min="0"
                                  >
                                  </md-input>

                                  <slide-y-down-transition>
                                    <md-icon class="error" v-show="failed"
                                      >close
                                    </md-icon>
                                  </slide-y-down-transition>
                                  <slide-y-down-transition>
                                    <md-icon class="success" v-show="passed"
                                      >done
                                    </md-icon>
                                  </slide-y-down-transition>
                                </md-field>
                                <div class="validate-error">
                                  {{ errors[0] }}
                                </div>
                              </ValidationProvider>
                            </div>
                          </div>
                        </div>

                        <!-- Total number of education programs  -->
                      </div>
                    </div>

                    <!-- Introduction  -->
                    <div class="md-layout-item md-size-100 md-xsmall-size-100">
                      <div class="md-layout">
                        <label
                          class="md-layout-item md-size-10 md-xsmall-size-100  md-form-label required-field"
                          :for="$t('university.introduction')"
                          style="padding-left: 10px;"
                        >
                          {{ $t("university.introduction") }}
                        </label>
                        <div
                          class="md-layout-item md-size-90 md-xsmall-size-100"
                        >
                          <ValidationProvider
                            :name="$t('university.introduction')"
                            rules="required"
                            v-slot="{ passed, failed, errors }"
                          >
                            <md-field
                              :class="[
                                { 'md-error': failed },
                                { 'md-valid': passed }
                              ]"
                            >
                              <div style="width: 100%">
                                <ckeditor
                                  @ready="onReady"
                                  :editor="editor"
                                  v-model="params.introduction"
                                  :config="editorConfig"
                                ></ckeditor>
                              </div>

                              <slide-y-down-transition>
                                <md-icon class="error" v-show="failed"
                                  >close
                                </md-icon>
                              </slide-y-down-transition>
                              <slide-y-down-transition>
                                <md-icon class="success" v-show="passed"
                                  >done
                                </md-icon>
                              </slide-y-down-transition>
                            </md-field>
                            <div class="validate-error">
                              {{ errors[0] }}
                            </div>
                          </ValidationProvider>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </md-card-content>

            <md-card-actions class="text-center">
              <md-button type="submit" class="md-success"
                >{{ $t("common.save") }}
              </md-button>
              <md-button native-type="button" @click="cancel"
                >{{ $t("common.cancel") }}
              </md-button>
            </md-card-actions>
          </md-card>
        </form>
      </ValidationObserver>
    </div>
    <!--  Avatar  -->
    <crop-upload-image-modal
      :modal-data="modalAvatar"
      :origin-img-src="imageCircle"
      :min-container-width="340"
      :min-container-height="260"
      :background="true"
      :rotatable="false"
      :img-style="{ width: '320px', height: '220px' }"
      :aspect-ratio="1"
      :click-outside-to-close="false"
      @closeModal="closeModalChangeAvatar"
      @setCroppedImageSrc="updateAvatar"
      :auto-crop-area="1"
    ></crop-upload-image-modal>

    <!--   Cover -->
    <crop-upload-image-modal
      :modal-data="modalCover"
      :origin-img-src="coverImageCircle"
      :min-container-width="320"
      :min-container-height="180"
      :background="true"
      :rotatable="false"
      :img-style="{ width: '320px', height: '180px' }"
      :aspect-ratio="16 / 9"
      :click-outside-to-close="false"
      :auto-crop-area="1"
      @closeModal="closeModalChangeCover"
      @setCroppedImageSrc="updateCover"
    ></crop-upload-image-modal>
  </div>
</template>

<script>
import CropUploadImageModal from "../../components/VueUploadMultipleImage/CropUploadImageModal";
import sanitizer from "sanitizer";
import { UniversityService } from "../../services/university.service";
import DecoupledEditor from "@ckeditor/ckeditor5-build-decoupled-document";
import CkeditorUploadAdapter from "@/helpers/ckeditor-upload-adapter";
import queryHelper from "@/helpers/query-helper";
import { UniversityTypeService } from "../../services/universityType.service";
import { UniversityDivisionService } from "../../services/universityDivision.service";
import { NationService } from "../../services/nation.service";
import { UniversityTemplateService } from "../../services/universityTemplate.service";
import { mapGetters, mapMutations } from "vuex";

export default {
  name: "UniversityCreateForm",
  components: { CropUploadImageModal },
  props: {
    id: {},
    editMode: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      video: null,
      coverImage: null,
      avatarImg: "../img/image_placeholder.jpg",
      modalAvatar: {
        show: false,
        action: "create"
      },
      modalCover: {
        show: false,
        action: "create"
      },
      imageCircle: "",
      coverImageCircle: "",
      formTitle: this.$t("page_title.university_create"),
      params: {
        code: null,
        name: null,
        vi_name: null,
        parent_id: null,
        university_division_id: null,
        university_type_id: null,
        is_public: true,
        cover_image: null,
        avatar: null,
        introduction: null,
        url: null,
        address: null,
        video: null,
        undergraduate: null,
        master: null,
        doctoral: null,
        staff_full_time: null,
        doctoral_full_time: null,
        staff_part_time: null,
        pap_full_time: null,
        undergraduate_program: null,
        doctoral_program: null,
        master_program: null,
        country_alpha_two_code: null,
        country_alpha_three_code: null
      },
      nationOptions: [],
      universityTypeOptions: [],
      universityDivisionOptions: [],
      universityTemplateOptions: [],
      universityOptions: [],
      editor: DecoupledEditor,
      editorConfig: {
        fontSize: {
          options: [
            8,
            9,
            10,
            11,
            12,
            13,
            "default",
            15,
            16,
            17,
            18,
            19,
            20,
            21,
            22,
            24,
            26,
            28,
            36,
            48
          ],
          supportAllValues: true
        },
        extraPlugins: [this.uploader],
        language: "vi"
      }
    };
  },
  mounted() {
    if (this.editMode) {
      this.getDetailUniversity(this.id);
    }
    this.getUniversityTemplateOptions();
    this.getUniversityTypeOptions();
    this.getUniversityDivisionOptions();
    this.getUniversity();
    this.getNationOptions();
  },
  methods: {
    ...mapMutations({
      setNationOptions: "SET_NATION_OPTIONS"
    }),
    onReady(editor) {
      // Insert the toolbar before the editable area.
      editor.ui
        .getEditableElement()
        .parentElement.insertBefore(
          editor.ui.view.toolbar.element,
          editor.ui.getEditableElement()
        );
    },
    async getDetailUniversity(id) {
      const info = await new UniversityService().getById(id);
      this.params.code = info.code;
      this.params.name = info.name;
      this.params.vi_name = info.vi_name;
      this.params.parent_id = info.parent_id;
      this.params.university_division_id = info.university_division_id;
      this.params.university_type_id = info.university_type_id;
      this.params.is_public = info.is_public;
      this.params.cover_image = info.cover_image;
      this.params.avatar = info.avatar;
      this.params.url = info.url;
      this.params.address = info.address;
      this.params.video = info.video;
      this.params.introduction = info.introduction;
      this.params.undergraduate = info.undergraduate;
      this.params.master = info.master;
      this.params.doctoral = info.doctoral;
      this.params.staff_full_time = info.staff_full_time;
      this.params.doctoral_full_time = info.doctoral_full_time;
      this.params.staff_part_time = info.staff_part_time;
      this.params.pap_full_time = info.pap_full_time;
      this.params.undergraduate_program = info.undergraduate_program;
      this.params.doctoral_program = info.doctoral_program;
      this.params.master_program = info.master_program;
      this.params.country_alpha_two_code = info.country_alpha_two_code;
      this.params.country_alpha_three_code = info.country_alpha_three_code;
      this.coverImage = info.cover_image;
      // this.video = info.video;
      //  get avatar image
      if (info.avatar !== null && info.avatar !== "") {
        this.imageCircle = info.avatar;
      }

      //get cover image
      if (info.cover_image !== null && info.cover_image !== "") {
        this.coverImageCircle = info.cover_image;
      }
    },
    changeCoverImg(coverImage) {
      if (coverImage) {
        this.params.cover_image = coverImage[0];
      }
    },
    // changeVideo(video) {
    //   if (video) {
    //     this.params.video = video[0];
    //   }
    // },
    async getNationOptions() {
      console.log(123);
      if (this.storeNationsOptions && this.storeNationsOptions.length > 0) {
        this.nationOptions = this.storeNationsOptions;
        return;
      }
      const response = new NationService().getListPublic();
      let nations = response.data;
      let nationOptions = [];
      nations.forEach(nation => {
        nationOptions.push({
          id: nation.alpha2Code,
          text: nation.name,
          country_alpha_three_code: nation.alpha3Code
        });
      });
      this.nationOptions = nationOptions;
      this.setNationOptions(nationOptions);
    },
    async getUniversityTemplateOptions() {
      const response = await new UniversityTemplateService().getList({
        limit: 1000
      });
      this.universityTemplateOptions = response.data;
      return response.data;
    },
    async getUniversityTypeOptions() {
      const response = await new UniversityTypeService().getList({
        limit: 1000
      });
      this.universityTypeOptions = response.data;
      return response.data;
    },
    async getUniversityDivisionOptions() {
      const response = await new UniversityDivisionService().getList({
        limit: 1000
      });
      this.universityDivisionOptions = response.data;
      return response.data;
    },
    async getUniversity() {
      const response = await new UniversityService().getList({
        limit: 1000
      });
      let universities = response.data;
      let universityOptions = [];
      universities.forEach(university => {
        if (parseInt(university.id) !== parseInt(this.id)) {
          universityOptions.push({
            id: university.id,
            text: university.name
          });
        }
      });
      this.universityOptions = universityOptions;
    },
    cancel() {
      this.$router.push({ name: "UniversityList" });
    },
    async submit() {
      let formData = this.buildFormDataCreateUniversity();
      if (this.editMode) {
        await this.updateUniversity(this.id, formData);
        return;
      }
      await this.createUniversity(formData);
    },
    async createUniversity(formData) {
      const response = await new UniversityService().create(formData);
      if (!response) return;
      this.$notify({
        title: this.$t("common.created"),
        text: this.$t("common.created_text", {
          name: this.$t("university.title"),
          value: sanitizer.escape(response.name)
        }),
        type: "success"
      });
      setTimeout(() => this.$router.push({ name: "UniversityList" }), 500);
    },
    async updateUniversity(id, formData) {
      const response = await new UniversityService().update(id, formData);
      if (!response) return;
      this.$notify({
        title: this.$t("common.updated"),
        text: this.$t("common.updated_text", {
          name: this.$t("university.title"),
          value: sanitizer.escape(response.name)
        }),
        type: "success"
      });
    },
    buildFormDataCreateUniversity() {
      let params = this.params;
      if (params.country_alpha_two_code) {
        const nation = this.nationOptions.find(
          ({ id }) => id == params.country_alpha_two_code
        );
        if (nation) {
          params.country_alpha_three_code = nation.country_alpha_three_code;
        }
      }
      if (this.editMode) {
        params._method = "PUT";
      }
      return queryHelper.buildFormData(params);
    },
    uploader(editor) {
      editor.plugins.get("FileRepository").createUploadAdapter = loader => {
        return new CkeditorUploadAdapter(loader);
      };
    },
    closeModalChangeAvatar() {
      this.modalAvatar.show = false;
      this.$store.commit("DESTROY_MODAL");
    },
    showModalChangeAvatar(action) {
      this.modalAvatar.action = action || "create";
      this.modalAvatar.show = true;
      this.$store.commit("SHOW_MODAL");
    },
    onFileChange(e) {
      this.showModalChangeAvatar("edit");
    },
    updateAvatar(file) {
      this.params.avatar = file;
      this.createImage(file, "circle");
    },
    createImage(file, type) {
      let reader = new FileReader();
      let vm = this;

      reader.onload = e => {
        if (type === "circle") {
          vm.imageCircle = e.target.result;
        }
      };
      reader.readAsDataURL(file);
    },
    closeModalChangeCover() {
      this.modalCover.show = false;
      this.$store.commit("DESTROY_MODAL");
    },
    showModalChangeCover(action) {
      this.modalCover.action = action || "create";
      this.modalCover.show = true;
      this.$store.commit("SHOW_MODAL");
    },
    onFileChangeCover(e) {
      this.showModalChangeCover("edit");
    },
    updateCover(file) {
      this.params.cover_image = file;
      this.createCoverImg(file, "circle");
    },
    createCoverImg(file, type) {
      let reader = new FileReader();
      let vm = this;

      reader.onload = e => {
        if (type === "circle") {
          vm.coverImageCircle = e.target.result;
        }
      };
      reader.readAsDataURL(file);
    }
  },
  watch: {
    id(newVal) {
      this.getDetailUniversity(newVal);
    }
  },
  computed: {
    ...mapGetters({ storeNationsOptions: "nationsOptions" })
  }
};
</script>

<style scoped lang="scss">
.md-card .md-card-actions {
  border: none;
}

.text-center {
  justify-content: center !important;
}

.md-field .success.md-icon,
.md-field .error.md-icon {
  right: -20px;
}

.image-fix-container {
  max-width: 250px;
  overflow: hidden;
  margin: 0 auto;
  margin-bottom: 10px;
  box-shadow: 0 10px 30px -12px rgb(0 0 0 / 42%), 0 4px 25px 0 rgb(0 0 0 / 12%),
    0 8px 10px -5px rgb(0 0 0 / 20%);
}

.content-button {
  margin: 0;
}

.management-uni-rating-container {
  text-align: right;
  margin: 10px 40px;
}

.management-uni-rating-container a {
  display: inline-block;
  text-align: center;
}

.management-uni-rating-container a:hover {
  cursor: pointer;
}

.management-uni-rating-container a i {
  padding: 10px;
  font-size: 16px;
  background: #9c27b0;
  border-radius: 10px;
}

.management-uni-rating-container a i.fa-pen:before {
  color: #ffffff;
}

.edit-btn {
  background: #9c27b0;
  color: #ffffff !important;
  font-size: 18px;
  border-radius: 8px;
  padding: 10px 10px;
  font-weight: 500;
}

#uni-avatar {
  margin-bottom: 30px;
}

.uni-count-container {
  h4 {
    margin: 10px 0 0;
    max-width: 320px;
    background: #4caf50;
    border-radius: 2px;
    padding: 5px;
    color: #ffffff;
    font-weight: 500;
    text-align: center;
  }
}

#uni-cover {
  margin-bottom: 30px;
  .file-input.img-circle {
    max-width: 250px;
  }
  .image-fix-container {
    max-width: 250px;
  }
}
</style>
